import { render, staticRenderFns } from "./ActivationBriefTasksProvider.vue?vue&type=template&id=2d581bfa&"
import script from "./ActivationBriefTasksProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefTasksProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports